/**
 * Created by WebStorm.
 * User: Mehedi Hasan
 * Date: 09 Jan 2025
 * Time: 10:21 AM
 * Email: mdmehedihasanroni28@gmail.com
 */

import React, {createContext, useState} from 'react';
import {getErrorMessage} from "../helpers/Utils";
import Notification from "../components/common/Notification";
import SubscriptionCouponService from "../services/SubscriptionCouponService";

export const SubscriptionCouponContext = createContext("PMSSubscriptionContext");

const SubscriptionCouponContextProvider = ({children}) => {

    const [loading, setLoading] = useState(false);
    const [subscriptionCouponList, setSubscriptionCouponList] = useState([]);
    const [totalElements, setTotalElements] = useState([]);

    const [addLoading, setAddLoading] = useState(false);

    const [editLoading, setEditLoading] = useState(false);

    const [subscriptionCoupon, setSubscriptionCoupon] = useState(null);

    async function getAllSubscriptionCoupon(params) {

        try {

            setLoading(true);

            const res = await SubscriptionCouponService.getAllSubscriptionCoupon(params);
            setSubscriptionCouponList(res.data.content);
            setTotalElements(res.data.content);

            setLoading(false);

            return res.data;

        } catch (error) {

            setLoading(false);

            const message = getErrorMessage(error);
            Notification("error", "ERROR", message);

            return false;
        }

    }

    async function addSubscriptionCoupon(data) {

        try {

            setAddLoading(true);

            await SubscriptionCouponService.addSubscriptionCoupon(data);
            Notification("success", "Coupon Created", "Subscription coupon has been created successfully");

            setAddLoading(false);

            return true;

        } catch (error) {

            setAddLoading(false);

            const message = getErrorMessage(error);
            Notification("error", "ERROR", message);

            return false;
        }

    }

    async function editSubscriptionCoupon(id, data) {

        try {

            setEditLoading(true);

            await SubscriptionCouponService.editSubscriptionCoupon(id, data);
            Notification("success", "Coupon Edited", "Subscription coupon has been edited successfully");

            setEditLoading(false);

            return true;

        } catch (error) {

            setEditLoading(false);

            const message = getErrorMessage(error);
            Notification("error", "ERROR", message);

            return false;
        }

    }

    async function getSubscriptionCoupon(id) {

        try {

            setLoading(true);

            const res = await SubscriptionCouponService.getSubscriptionCoupon(id);
            setSubscriptionCoupon(res.data);

            setLoading(false);

            return true;

        } catch (error) {

            setLoading(false);

            const message = getErrorMessage(error);
            Notification("error", "ERROR", message);

            return false;
        }

    }

    return (
        <SubscriptionCouponContext.Provider
            value={{
                loading,
                totalElements,
                subscriptionCouponList,
                getAllSubscriptionCoupon,
                addSubscriptionCoupon,
                addLoading,
                editSubscriptionCoupon,
                editLoading,
                getSubscriptionCoupon,
                subscriptionCoupon,
            }}
        >
            {children}
        </SubscriptionCouponContext.Provider>
    );
}

export default SubscriptionCouponContextProvider;

